import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ContainerFlex } from '@prima-afp/prima-ui-design-system/dist/layouts';
import { Button } from "@prima-afp/prima-ui-elements/dist/core";
import { useHistory, useLocation } from "react-router-dom";
import { useStateDigitalTransfersContext, useDispatchDigitalTransfersContext} from "../../../../context/DigitalTransfersContext";
import { NoValidLink } from "../resources/index"
import { Typography } from "@prima-afp/prima-ui-design-system/dist/ui-components";
import { clearUserDatafromNavigator } from "../../../../constants/buildBody";
import { InvalidLinkContainer, ButtonsContainer } from "../../../Style"; 
import {sendToData} from '../../../../constants/sendToDataLayer';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const InvalidLink = ({ componentButton = null }) => {


  const [ timer, setTimer ] = useState(12);
  let interval = useRef();

  const query = useQuery();
  const idUser = query.get('idUser');
  const history = useHistory();
  const {
      userWeb,
  } = useStateDigitalTransfersContext(); 
  const dispatch = useDispatchDigitalTransfersContext();

  useEffect(() => {

    let copyOfTimer = 12;
    interval.current = setInterval(() => {
      if (copyOfTimer > 0) {
        copyOfTimer--;
        setTimer(copyOfTimer);
      } else { clearInterval(interval.current) }
    }, 1000);

    return () => clearInterval(interval.current);
  }, []);

  const restartFlow = async  () => {
    const currentUrl = window.location.href;
    var payload = {section: "continuar traspaso link invalido", option: "reiniciar trámite"};
    sendToData(currentUrl, "button_click", "button_click", payload);    

    clearUserDatafromNavigator();
    dispatch({ type: "INITIAL_STATE" });
    history.push('/pasos0')

  }; 

  return (
    <ContainerFlex all={{
      flexDirection: 'column',
      gap: '2rem',
      alignItems: 'stretch',
      padding: '0',
    }}>
      <InvalidLinkContainer>
        <div id="SectionImg">
          <img
              loading="lazy"
              src={NoValidLink}
              className="img1"
          />
        </div>
        <div id="MessageSection">
          <Typography
            align="center"
            bold
            color="#4E5258"
            variant="h4"
          >
              Este enlace ha expirado
          </Typography>
          <span id="MessageSectiontext">
            El link solo se puede usar dentro de las primeras <b> 72 horas </b> y solo puede ser usado una vez. Si lo deseas, puedes volver a realizar tu trámite.
          </span>
          <ButtonsContainer>
            <Button
              onClick={() => restartFlow()}
              className={"newUiBtn enabledBtn"}
            >
              Reiniciar trámite
            </Button>  
          </ButtonsContainer>      
        </div>
      </InvalidLinkContainer>


    </ContainerFlex>
  );
};

InvalidLink.propTypes = {
  componentButton: PropTypes.node,
};

InvalidLink.defaultProps = {
  componentButton: null,
};

export default InvalidLink;